import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { NewTaxiRideComponent } from '../new-taxi-ride/new-taxi-ride.component';

@Component({
  selector: 'app-taxi-ride-edit-modal',
  templateUrl: './taxi-ride-edit-modal.component.html',
  styleUrls: ['./taxi-ride-edit-modal.component.css']
})
export class TaxiRideEditModalComponent implements OnInit, OnDestroy {
  @ViewChild('newTaxiRideComponent', { static: false }) tripComponent: NewTaxiRideComponent;
  @Input() tripId: any;
  @Input() isStandingOrderClone?: any;
  @Output() onCloseModal = new EventEmitter<string>();
  @Output() onUpdate = new EventEmitter<string>();
  isHideUpdateAction = true;

  constructor() { }

  ngOnInit() { }

  saveTaxiRide() {
    this.tripComponent.onCreateTrip();
  }

  onUpdateTrip(event) {
    this.onUpdate.emit(event);
  }

  closeModal() {
    this.onCloseModal.emit();
  }

  ngOnDestroy() {
  }
}
